export const logDeprecationNote = (message: string) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[DEPRECATION NOTE] ${message}`);
  }
};
